import React, { Component, Fragment } from 'react';
import SweetAlert from 'react-bootstrap-sweetalert';
import api from '../../../services/api';
import { Container, Table } from './styles';

import Button from '../../../components/Button';
import Input from '../../../components/Input';
import Loading from '../../../components/Loading';

export default class Producers extends Component {
  state = {
    alert: {},
    loading: true,
    producers: [],
    searchNameInput: '',
    filteredResults: [],
    showAlert: false,
  };

  componentDidMount() {
    this.loadProducers();
  }

  loadProducers = async () => {
    try {
      const { data } = await api.get('admin/producers', {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
        params: {
          results: 0,
        },
      });

      const { producers } = data;

      this.setState({ producers, filteredResults: producers, loading: false });
    } catch (err) {
      this.setState({ producers: [] });
    }
  };

  blockProducer = async (id, status) => {
    const { producers } = this.state;
    const formData = new FormData();
    formData.append('status', status);
    try {
      await api.put(`admin/producers/${id}`, formData, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token_admin')}`,
        },
      });

      const updatedProducers = [...producers];
      const index = updatedProducers.findIndex(x => x.id === id);
      updatedProducers[index].status = status;

      this.setState({ producers: updatedProducers });

      this.filterResults();
    } catch (err) {
      const messages = err.response
        ? err.response.data.errors
        : ['Não foi possível bloquear o produtor. Por favor, atualize a página.'];
      this.setState(
        {
          alert: {
            title: 'Erro',
            type: 'danger',
            messages,
            onConfirm: () => this.closeAlert(),
          },
        },
        () => {
          this.openAlert();
        },
      );
    }
  };

  openAlert = () => {
    this.setState({
      showAlert: true,
    });
  };

  closeAlert = () => {
    this.setState({
      showAlert: false,
    });
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value }, () => {
      this.filterResults();
    });
  };

  filterResults = () => {
    const { producers, searchNameInput } = this.state;

    let filteredResults = producers;

    if (searchNameInput.length > 0) {
      filteredResults = filteredResults.filter(producer =>
        producer.name.toLowerCase().includes(searchNameInput.toLowerCase()));
    }

    this.setState({ filteredResults });
  };

  render() {
    const {
      alert: {
        cancelBtnText,
        cancelBtnBsStyle,
        confirmBtnText,
        confirmBtnBsStyle,
        messages,
        onConfirm,
        showCancel,
        title,
        type,
      },
      filteredResults,
      loading,
      producers,
      searchNameInput,
      showAlert,
    } = this.state;

    return (
      <Fragment>
        {loading ? (
          <Loading />
        ) : (
          <Container>
            <h1 className="page-title">Produtores {filteredResults && ` (${filteredResults.length})`}</h1>
            <div className="box">
              <div className="row">
                {producers.length !== 0 && (
                  <div className="col-12">
                    <div className="box-header">
                      <div className="filter">
                        <Input
                          name="searchNameInput"
                          onChange={this.handleChange}
                          placeholder="Nome"
                          value={searchNameInput}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="row">
                <div className="col-12">
                  {filteredResults.length > 0 ? (
                    <div className="table-wrapper">
                      <Table className="table">
                        <thead>
                          <tr>
                            <th>Foto</th>
                            <th>Nome</th>
                            <th>Email</th>
                            <th>CPF</th>
                            <th>CNPJ</th>
                            <th>Telefone</th>
                            <th>Bloquear / Desbloquear</th>
                          </tr>
                        </thead>
                        <tbody>
                          {filteredResults.map(producer => (
                            <tr key={producer.id}>
                              <td>
                                <div
                                  className="profile-image"
                                  style={
                                    producer.avatar.url && {
                                      backgroundImage: `url(${producer.avatar.url})`,
                                    }
                                  }
                                />
                              </td>
                              <td>{producer.name}</td>
                              <td>{producer.email}</td>
                              <td>{producer.cpf}</td>
                              <td>{producer.cnpj}</td>
                              <td>{producer.phone}</td>
                              <td>
                                {producer.status === 'active' ? (
                                  <Button
                                    onClick={() => this.blockProducer(producer.id, 'blocked')}
                                    className="btn-outline-danger btn-small"
                                  >
                                    Bloquear
                                  </Button>
                                ) : (
                                  <Button
                                    onClick={() => this.blockProducer(producer.id, 'active')}
                                    className="btn-outline-success btn-small"
                                  >
                                    Desbloquear
                                  </Button>
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                  ) : (
                    <h5 className="text-center">
                      Não existem produtores com os filtros selecionados.
                    </h5>
                  )}
                </div>
              </div>
            </div>
            {showAlert && (
              <SweetAlert
                type={type}
                confirmBtnText={confirmBtnText}
                confirmBtnBsStyle={confirmBtnBsStyle}
                showCancel={showCancel}
                cancelBtnText={cancelBtnText}
                cancelBtnBsStyle={cancelBtnBsStyle}
                title={title}
                onConfirm={onConfirm}
                onCancel={this.closeAlert}
              >
                <ul>
                  {messages.map(msg => (
                    <li key={msg}>{msg}</li>
                  ))}
                </ul>
              </SweetAlert>
            )}
          </Container>
        )}
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// ./src/admin/pages/Producers/index.js